import React from "react";
import {
  CNavItem,
  CSidebar,
  CSidebarBrand,
  CSidebarHeader,
  CSidebarNav,
} from "@coreui/react";
import navigation from "../../utils/navLinks";
import { useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
import NavbarLogo from "../navbarLogo";

/**
 * @function AppSidebar
 * @description for Sider
 * @returns JSX for Sider
 */

const AppSidebar = () => {
  const { pathname } = useLocation();
  return (
    <CSidebar className="border-end" colorScheme="light" position="fixed">
      <CSidebarHeader className="border-bottom logo-contanier">
        <NavbarLogo />
      </CSidebarHeader>
      <CSidebarNav as={SimpleBar} style={{ overflow: "hidden" }}>
        {navigation.map((item, i) => {
          return (
            <CNavItem
              key={i}
              href={item.to}
              {...(pathname.includes(item.to) && {
                active: true,
                className: "active-link",
              })}
            >
              <span
                {...(pathname.includes(item.to) && {
                  style: { "--ci-primary-color": "#5856d6" },
                })}
              >
                {item.icon}
              </span>
              <span>{item.name}</span>
            </CNavItem>
          );
        })}
      </CSidebarNav>
    </CSidebar>
  );
};

export default React.memo(AppSidebar);
